import type { ReactNode } from "react";
import { cn } from "../lib/cn";
import { CheckCircleIcon, ClockIcon } from "./icons";

export type BadgeTone = "pending" | "active" | "error" | "neutral";

interface BadgeProps {
  tone: BadgeTone;
  children: ReactNode;
  className?: string | undefined;
}

const toneStyles: Record<BadgeTone, string> = {
  pending: "bg-lemon text-ochre",
  active: "bg-mint text-forest",
  error: "bg-pale-red text-error-red",
  neutral: "bg-ice text-deep-navy",
};

const toneIcons: Partial<Record<BadgeTone, ReactNode>> = {
  pending: <ClockIcon size={16} className="shrink-0" />,
  active: <CheckCircleIcon size={16} className="shrink-0" />,
};

/** Status pill. */
export function Badge({ tone, children, className }: BadgeProps): ReactNode {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold leading-[1.5]",
        toneStyles[tone],
        className,
      )}
    >
      {toneIcons[tone]}
      {children}
    </span>
  );
}
